import React from 'react';
import _ from 'lodash';
import Picker from '../../forms/Picker';

/**
 * Edit picker cell component
 * @module
 * @param {func} getProps - Get props function
 * @param {func} itemChange - Item Change function
 * @param {func} getColumns - Get columns function
 */
export function EditPickerCell({ getProps, itemChange, getColumns, withMeta }) {

  return class extends React.Component {

    handleChange = (name, selected) => {
      itemChange({
        dataItem: this.props.dataItem,
        field: name,
        value: selected
      });
    };

    getValue = (dataValue, column) => {
      let field = column.valueField;
      let toReplace = field?.match(/{([^}]+)}/g);
      if (toReplace) {
        toReplace.forEach((element) => {
          let propName = element.replace(/[{}]/g, "");
          const replaceWith = _.get(dataValue, propName);
          field = field.replace(
            element,
            replaceWith != null ? replaceWith : ""
          );
        });
        return field;
      }
      else {
        return _.get(dataValue, this.props.field.split('.').slice(1))
      }
    }

    render() {
      const getedProps = getProps();
      const { dataItem, field } = this.props;
      const splitField = field.split(".")[0];
      const dataValue = dataItem[splitField] === null ? '' : dataItem[splitField];

      const x = getColumns().find(item =>
        item.field === splitField && item.textField === field.substring(field.indexOf('.') + 1)
      )
      const selected = this.props.dataItem[splitField];
      const data = getedProps.parentProps[x.data];
      const className = (dataItem.inEdit ? "k-grid-edit-cell " : "") + this.props.className;

      const td =
        (
          <td colSpan={this.props.colSpan}
            className={className}
            style={this.props.style}
            role="gridcell"
            aria-colindex={(this.props.columnIndex || 0) - (this.props.level || 0) + 1}
            aria-selected={false}
            tabIndex="0"
          >
            {((dataItem.inEdit === true || dataItem.inEdit === splitField) && x.editable !== false) ? (
              <Picker
                textField={x.textField}
                valueField={x.valueField || x.textField}
                onChange={getedProps.parentProps[x.onChange]}
                //onSubmit={this.props.parentProps[x.onSubmit]}
                data={data ? data.data : []}
                isLoading={data ? data.isLoading : false}
                onSelect={this.handleChange}
                selected={selected}
                schema={x.schema}
                total={data ? data.total : 0}
                disabled={x.disabled}
                name={x.field}
                primaryField={x.primaryField}
                identif={x.Identif}
                title={x.title}
                fixedFilter={x.fixedFilter}
                required={x.required}
                /*isOpen={this.state.isOpenPicker}*/
                openPicker={this.handleOpenPicker}
                closePicker={this.handleClosePicker}
                placeholder={"Zvoľte hodnotu"}
                currentDataItem={dataItem}
                parentProps={getedProps.parentProps}
                withMeta={withMeta}
              />
            ) : (
              this.getValue(dataValue, x)
            )
            }
          </td>);

      return this.props.render ? this.props.render.call(undefined, td, this.props) : td;
    }
  }

}
